module.exports = __webpack_public_path__ + "img/classify_img3.d23f98a7.png";